import { Button, TextInput } from "@tremor/react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { AlertBox } from "../../ui/";
import { adminAPI } from "../../api/adminAPI";
import { getDrivers } from "../../store/admin";

export const RegisterDriverModal = ({ cancelFunction }) => {
  const { jwt } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (dataValues) => {
    const { nameDriver, phoneDriver } = dataValues;

    const headers = {
      "x-token": jwt,
    };
    const resp = await adminAPI
      .post(
        "/drivers",
        {
          name: nameDriver,
          phone: phoneDriver,
        },
        { headers }
      )
      .catch(({ response }) => response);
    const { data } = resp;
    if (resp.status !== 200) {
      const errors = data.message
        ? [data.message]
        : data.errors.map((err) => err.msg);
      AlertBox({ color: "warning", messages: errors });
    }
    AlertBox({ color: "success", messages: [data.message] });
    dispatch(getDrivers());
    cancelFunction();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="bg-white p-6 rounded shadow-lg z-10">
        <h2 className="text-xl font-bold mb-4">Registrar Nuevo Conductor</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <p>Nombre</p>
            <TextInput
              name="nameDriver"
              placeholder="Juan Pérez"
              {...register("nameDriver", {
                required: {
                  value: true,
                  message: "El nombre es requerido",
                },
              })}
            ></TextInput>
            {errors.nameDriver && (
              <span className="text-red-500 text-sm">
                {errors.nameDriver.message}
              </span>
            )}
          </div>
          <div>
            <p>Numero Telefonico</p>
            <TextInput
              name="phoneDriver"
              placeholder="81 0000 0000"
              {...register("phoneDriver", {
                required: {
                  value: true,
                  message: "El numero telefonico es requerido",
                },
                pattern: {
                  value: /^[0-9]{2} [0-9]{4} [0-9]{4}$/,
                  message:
                    "El numero telefonico debe tener el formato 81 0000 0000",
                },
              })}
            ></TextInput>
            {errors.phoneDriver && (
              <span className="text-red-500 text-sm">
                {errors.phoneDriver.message}
              </span>
            )}
          </div>
          <div className="flex justify-between mt-2">
            <Button variant="secondary" onClick={cancelFunction}>
              Cerrar
            </Button>
            <Button type="submit">Guardar</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

RegisterDriverModal.propTypes = {
  cancelFunction: PropTypes.func,
};
